import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { StructureInstructionsPopup } from './StructureInstructionsPopup';

export const STRUCTURE_INSTRUCTIONS_POPUP = Symbol('STRUCTURE_INSTRUCTIONS');

/**
 * Use "structure instructions" popup
 *
 * @returns {(function({
 *   generationTool: GENERATION_TOOL,
 *   language: LANGUAGE,
 *   [initialValue]: Object,
 *   [eventPage]: EVENT_PAGE,
 *   [instructionTypes]: PROMPT_INSTRUCTION_TYPE[],
 * }): Promise<Object | null>)}
 */
export const useStructureInstructionsPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(STRUCTURE_INSTRUCTIONS_POPUP, StructureInstructionsPopup);
  });

  return useCallback(
    ({ generationTool, language, initialValue, eventPage, instructionTypes }) => {
      return new Promise((resolve) => {
        popups.openPopup(STRUCTURE_INSTRUCTIONS_POPUP, {
          generationTool,
          language,
          initialValue,
          eventPage,
          instructionTypes,

          onSubmit: (structureInstructionsData) => {
            popups.closePopup(STRUCTURE_INSTRUCTIONS_POPUP);
            resolve(structureInstructionsData);
          },
          onClose: () => {
            popups.closePopup(STRUCTURE_INSTRUCTIONS_POPUP);
            resolve(null);
          },
        });
      });
    },
    [popups]
  );
};
